module.exports = __webpack_public_path__ + "media/taipei/taipei street-2f1af90f.jpg";